console.log('custom js');

function checkScroll() {
    // Get the current scroll position
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;


    const body = document.body;

   
    const siteHeader = document.querySelector('.site-header');
    console.log('scrollPosition', scrollPosition);
    // Check if the scroll position is greater than or equal to 80
    if (scrollPosition > 150) {
        body.classList.add('site-headersticky');
        siteHeader.classList.add('site-header-sticky-scrolled');
        
    } 
    else {
        body.classList.remove('site-headersticky');
   
        siteHeader.classList.remove('site-header-sticky-scrolled');
    
    }

    if(scrollPosition <= 150){
        body.classList.remove('site-headersticky');
        siteHeader.classList.remove('site-header-sticky-scrolled');
    }

    if (scrollPosition > 20) {
        siteHeader.classList.add('site-pos-header');
        
    } 
    else {
        siteHeader.classList.remove('site-pos-header');    
    }
}

// Event listener for scroll events
window.addEventListener('scroll', checkScroll);

// Check scroll position on page load
window.addEventListener('load', () => {
    checkScroll();
});


// Brands - custom development (Not for 'Brands all' )
if ($('.brand-nav-wrapper.brands-all').length == 0){
  document.querySelectorAll('.single-letter-button').forEach(button => {
      button.addEventListener('click', function() {
          const letter = this.getAttribute('data-navletter');

          // Hide all letter wrappers and remove "No content" if it exists
          document.querySelectorAll('.letter-wrapper').forEach(wrapper => {
              wrapper.style.display = 'none';
              const noContentDiv = wrapper.querySelector('.no-content');
              if (noContentDiv) {
                  noContentDiv.remove(); // Remove "No content" if it exists
              }
          });

          // Show the corresponding letter wrapper
          const matchingWrapper = document.querySelector(`.letter-wrapper[data-letter="${letter}"]`);
          if (matchingWrapper) {
              // Check if the wrapper has children
              if (matchingWrapper.children.length === 0) {
                  // Create and append "No content" message
                  const noContentDiv = document.createElement('div');
                  noContentDiv.className = 'no-content';
                  noContentDiv.innerHTML = 'No Brands. <a href="/collections/all">Continue Shopping</a>';
                  matchingWrapper.appendChild(noContentDiv);
              }
              matchingWrapper.style.display = 'flex';
          }

          // Remove 'active' class from all buttons
          document.querySelectorAll('.single-letter-button').forEach(btn => {
              btn.classList.remove('active');
          });

          // Add 'active' class to the clicked button
          this.classList.add('active');
      });
  });
}


// Tooltip function
// function tooltip(e){
//   let tooltip = $('.small-promo-content .tooltip')
//   let hasActiveClass = tooltip.hasClass('active')
//   if ( hasActiveClass ){
//     tooltip.removeClass('active')
//   }else {
//     tooltip.addClass('active')
//   }
// }

document.addEventListener('DOMContentLoaded', function () {
  // Select all the featured collection containers
  const collections = document.querySelectorAll('.featured-collection__container');

  collections.forEach(function(collection) {
    // Get all items inside this collection (exclude the title card from being a pgi item)
    const pgiItems = collection.querySelectorAll('.productgrid--item.pgi');
    
    // Loop through each pgi item
    pgiItems.forEach(function(pgiItem) {
      // Find the sibling .productgrid--item.featured-collection__title-card
      const titleCard = pgiItem.closest('.featured-collection__container').querySelector('.productgrid--item.featured-collection__title-card');
      // If the titleCard exists
      if (titleCard) {

        // Get the height of the pgi item
        const pgiHeight = pgiItem.offsetHeight;
        
        // Set the height of the title card to match the height of the pgi item
        titleCard.style.height = `${pgiHeight}px`;
      }
    });
  });
});

(function() {
  // Wait for the DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Select all the featured collection wrappers (sliders)
    const sliders = document.querySelectorAll('.featured-collection__content');
    
    // Iterate over each slider wrapper on the page
    sliders.forEach(function(slider) {
      // Initialize Flickity if it's not already initialized
      let flickityInstance = slider.Flickity; // Assuming Flickity instance is saved directly to the element (common practice)
      console.log('XX slider', flickityInstance);

      if (flickityInstance) {
        // Bind the 'cellSelect' event for logging slide change
        flickityInstance.on('cellSelect', function() {
          console.log('#### Slide changed!');
        });
      } else {
        console.warn('No Flickity instance found for this slider!');
      }
    });
  });
})();



function clickScrollEffect(e){

}